import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";

const GuestLogoutButton: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { logout ,redirectGuestScreen} = rootStore.guestStore;
  const [t] = useTranslation(["guest"], translationHookOptions);
  const pathAfterGuest = window.location.href.split("/guest")[1]; // Ottiene tutto dopo "/guest"

  return (
    <>
      <Button
        id="btnLeaveMeeting"
        color=""
        className="navbarButton navbarButtonEnabled mr-2"
        onClick={() => logout(pathAfterGuest).then((dto) => { if(dto) redirectGuestScreen(pathAfterGuest) })}
      >
        <span className="font-size-80 font-weight-bold mr-2 d-none d-lg-inline-block">
          {t("guest_logout")}
        </span>
        <i className={"fas fa-sign-out-alt align-middle fa-lg"}></i>
      </Button>
    </>
  );
};

export default observer(GuestLogoutButton);
